// Complete Plant Database
// Combines all plant categories

import { PlantData } from './plants-master-database'
import { coreVegetablesData } from './plants-core-vegetables'
import { moreVegetablesData } from './plants-more-vegetables'
import { cucurbitsData } from './plants-cucurbits'
import { alliumsData } from './plants-alliums'
import { treesData } from './plants-trees'
import { additionalData } from './plants-additional'
import { berriesData } from './plants-berries'
import { mushroomsData } from './plants-mushrooms'
import { bonusData } from './plants-bonus'
import { bonusData2 } from './plants-bonus-2'
import { shadeData } from './plants-shade'
import { tropicalData } from './plants-tropical'

export type { PlantData }

export const allPlants: PlantData[] = [
  ...coreVegetablesData,
  ...moreVegetablesData,
  ...cucurbitsData,
  ...alliumsData,
  ...treesData,
  ...additionalData,
  ...berriesData,
  ...mushroomsData,
  ...bonusData,
  ...bonusData2,
  ...shadeData,
  ...tropicalData,
]

export const plantsByCategory = {
  vegetables: allPlants.filter(p => p.category === 'vegetable'),
  herbs: allPlants.filter(p => p.category === 'herb'),
  flowers: allPlants.filter(p => p.category === 'flower'),
  fruits: allPlants.filter(p => p.category === 'fruit'),
  berries: allPlants.filter(p => p.category === 'berry'),
  mushrooms: allPlants.filter(p => p.category === 'mushroom'),
  trees: allPlants.filter(p => p.category === 'tree'),
  alliums: allPlants.filter(p => p.category === 'allium'),
  cucurbits: allPlants.filter(p => p.category === 'cucurbit'),
  legumes: allPlants.filter(p => p.category === 'legume'),
  grains: allPlants.filter(p => p.category === 'grain'),
  microgreens: allPlants.filter(p => p.category === 'microgreen'),
  sprouts: allPlants.filter(p => p.category === 'sprout'),
  coverCrops: allPlants.filter(p => p.category === 'cover_crop'),
  tropical: allPlants.filter(p => p.category === 'tropical'),
}

export const plantCounts = {
  total: allPlants.length,
  vegetables: allPlants.filter(p => p.category === 'vegetable').length,
  herbs: allPlants.filter(p => p.category === 'herb').length,
  flowers: allPlants.filter(p => p.category === 'flower').length,
  fruits: allPlants.filter(p => p.category === 'fruit').length,
  berries: allPlants.filter(p => p.category === 'berry').length,
  mushrooms: allPlants.filter(p => p.category === 'mushroom').length,
  trees: allPlants.filter(p => p.category === 'tree').length,
  alliums: allPlants.filter(p => p.category === 'allium').length,
  cucurbits: allPlants.filter(p => p.category === 'cucurbit').length,
  legumes: allPlants.filter(p => p.category === 'legume').length,
  grains: allPlants.filter(p => p.category === 'grain').length,
  microgreens: allPlants.filter(p => p.category === 'microgreen').length,
  sprouts: allPlants.filter(p => p.category === 'sprout').length,
  coverCrops: allPlants.filter(p => p.category === 'cover_crop').length,
}

export default allPlants
